import { SeverityLevel } from "@microsoft/applicationinsights-web";

import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import { UNHANDLED_REJECTION_EVENT_NAME } from "./constants";
import { App } from "./features/app";
import { createRoot } from "react-dom/client";
import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";
import { BrowserRouter as Router } from "react-router-dom";
import { I18nextProvider, ErrorBoundary, trackError } from "@fortius/prime-ui";

import { I18NextInit } from "commons/locales/components";
import { i18next } from "commons/locales";
import { OfaThemeProvider } from "commons/theme";
import { Application, AppProvider } from "commons/components";
import { initCommonClients } from "commons/clients/initCommonClients";

(async function bootstrap() {
  const rootEl = document.getElementById("root");

  if (!rootEl) {
    return;
  }

  const root = createRoot(rootEl);
  const LDProvider = await asyncWithLDProvider({
    clientSideID: window.appConfig.ld_clientId
  });

  window.addEventListener("unhandledrejection", errEvent => {
    trackError(errEvent.reason, UNHANDLED_REJECTION_EVENT_NAME, SeverityLevel.Error);
  });

  const application = new Application();

  initCommonClients(application);

  root.render(
    <LDProvider>
      <Router basename={process.env.PUBLIC_URL}>
        <I18nextProvider i18n={i18next}>
          <I18NextInit>
            <OfaThemeProvider>
              <AppProvider application={application}>
                <ErrorBoundary>
                  <App />
                </ErrorBoundary>
              </AppProvider>
            </OfaThemeProvider>
          </I18NextInit>
        </I18nextProvider>
      </Router>
    </LDProvider>
  );
})();
